import { createCamera } from "./components/camera";
import { createRenderer } from "./systems/renderer";
import { createScene } from "./components/scene";
import { Loop } from "./systems/loop";
import { createControls } from "./systems/controls";
import { createLights } from "./components/lights";
import { Resizer } from "./systems/resizer";
import { Globe } from "./components/globe";
import { pointOfView } from "./systems/utils";
import { IPA_GLOBE_DEFAULTS } from "./ipa-globe-defaults";

class World {
  constructor(container, userOptions = {}) {
    this.options = { ...IPA_GLOBE_DEFAULTS, ...userOptions };

    this.renderer = createRenderer(container);
    this.scene = createScene();
    this.camera = createCamera(container);

    this.loop = new Loop(this.camera, this.scene, this.renderer);
    this.controls = createControls(this.camera, this.renderer.domElement);
    this.controls.update();
    this.loop.updatables.push(this.controls);

    const { ambientLight, dLight, dLight1, dLight2 } = createLights();
    this.camera.add(ambientLight, dLight, dLight1, dLight2);

    this.globe = new Globe(this.options);
    this.globe.init();
    this.loop.updatables.push(this.globe.instance);

    this.scene.add(this.camera, this.globe.instance);

    pointOfView(
      this.camera,
      this.controls,
      this.globe.instance,
      {
        lat: this.options.povLat,
        lng: this.options.povLng,
        altitude: this.options.povAltitude,
      },
      this.options.povTransitionMs
    );

    this.resizer = new Resizer(container, this.camera, this.renderer);

    container.append(this.renderer.domElement);
    this.globe.attachToCanvas(this.renderer.domElement, this.camera);
  }

  render() {
    this.renderer.render(this.scene, this.camera);
  }

  start() {
    this.loop.start();
  }

  stop() {
    this.loop.stop();
  }
}

export { World };
